import useSWRMutation from "swr/mutation";
import { ServicesURL, getQueryString } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { EditionKind } from "../types";

interface DeleteEditionArgs {
  editionId: string | number;
  corporateId: string | number;
}

export const useDeleteEdition = (kind: EditionKind) => {
  const baseUrl =
    kind === "virtual" ? ServicesURL.deleteVirtual : ServicesURL.deletePhysical;

  const { trigger, isMutating } = useSWRMutation(
    baseUrl,
    (url: string, { arg }: { arg: DeleteEditionArgs }) =>
      fetcher<any>(
        getQueryString(`${url}/${arg.editionId}`, {
          corporateId: String(arg.corporateId),
        }),
        MethodType.DELETE,
      ),
  );

  return { deleteEdition: trigger, isDeleting: isMutating };
};
